import { useTranslation } from '@klv/hooks/useTranslation';

import Icon from '@klaviyo-mkt/gatsby-components/atoms/icon';

import useIsSearchPage from '@klaviyo-mkt/gatsby-components/hooks/useIsSearchPage';
import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';

import * as styles from './styles/search.module.scss';

import type { INoResults } from './types';

const NoResults = ({ query }: INoResults) => {
  const { t } = useTranslation();
  const isSearchPage = useIsSearchPage();

  if (isSearchPage) {
    return (
      <div className={styles.noResultsWrapper}>
        <Icon iconName='BugMarkOutlined' />
        <div className={generateClassName(['p1', 'semibold'])}>{t('helpCenter_templates_search_noResults_noResultsWrapperText')}{query}</div>
        <div className={generateClassName(['p2'])}>{t('helpCenter_templates_search_noResults_noResultsWrapperSuggestion')}</div>
      </div>
    );
  }

  return (
    <div className={styles.instantSearchNoResults}>
      <div className='p2'>{t('helpCenter_templates_search_noResults_noResultsInstantSearch')}</div>
    </div>
  );
};

export default NoResults;
